/*
 * @name: 萝卜兄台
 * @Date: 2022-07-14 11:14:30
 * @LastEditors: DESKTOP-IQPBHI4\mi leili995997651@qq.com
 * @LastEditTime: 2022-07-14 11:25:20
 * @FilePath: \vue3-vite-ts-demo\src\store\index.ts
 * @Description: 这是描述
 */
import { createPinia } from 'pinia'

const store = createPinia()

export default store